module.exports = "<div class=\"container-fluid marquee-row\">\n        <div class=\"row\"> \n            <marquee-cell [images]=\"(item|meta).images\" [title]=\"(item|meta).title\" [subtitle]=\"(item|meta).sub_title\" [direction]=\"'left'\" [disable]=\"disable\" >\n                <ng-content></ng-content>\n            </marquee-cell>\n        </div>\n    </div>\n    "


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/marquee/marquee-row/marquee-row.template.html
// module id = 728
// module chunks = 2